module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/A97PeS/tc-custom/9781426855009.jpg?1740862301686",
      "alt": "This image is the cover for the book Tamed: Barbarian King"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tamed: Barbarian King\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A king longs for the woman he lost to another man in this forbidden romance from a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("He’s as wild as the desert, a barbarian prince, a revered leader. Long ago he loved a girl, but the power of their feelings almost destroyed them both. Now that woman, the only one he could ever love, is forbidden to him!"), _c('br'), _c('br'), _vm._v("Betrothed to another, unable to bear him sons, she is unfit to be his queen. . . . But she can stop the storm that has raged in his heart since he last made her his."), _c('br'), _c('br'), _vm._v("His choice—take her as his mistress, or become the king he was born to be. . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jennie Lucas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jennie Lucas's parents owned a bookstore and she grew up surrounded by books, dreaming about faraway lands. At twenty-two she met her future husband and after their marriage, she graduated from university with a degree in English. She started writing books a year later. Jennie won the Romance Writers of America’s Golden Heart contest in 2005 and hasn’t looked back since. Visit Jennie’s website at: www.jennielucas.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0